<template>
  <div class="modalFormWrap formStyle">
    <div :class="{'bdTop mgTop': i!=0}" v-for="(e, i) in newInfo" :key="i">
      <p class="textRight pdBtm" v-if="!e.id && i>0"><span class="removeBtn" @click="remove(i)"><Icon type="ios-trash-outline" size="18" />删除</span></p>
      <Form :ref="`newForm${i}`" :model="e" :rules="rules">
        <Row :gutter="30">
          <Col span="12">
            <FormItem prop="startYear" label="开始时间">
              <DatePicker type="year" :clearable="false" :editable="false" v-model="e.startYear" @on-change="(val, type)=>{setStartYear(val, type, i)}"></DatePicker>   
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="endYear" label="结束时间">
              <DatePicker type="year" :clearable="false" :editable="false" v-model="e.endYear" @on-change="(val, type)=>{setEndYear(val, type, i)}"></DatePicker>   
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="company" label="工作单位">
              <Input type="text" v-model="e.company"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="job" label="职务">
              <Input type="text" v-model="e.job"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="witnessName" label="证明人姓名">
              <Input type="text" v-model="e.witnessName"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="witnessPhone" label="证明人手机">
              <Input type="tel" v-model="e.witnessPhone"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="witnessRelation" label="您是证明人的">
              <Select v-model="e.witnessRelation" placeholder="">
                <Option value="SUBORDINATE">下属</Option>
                <Option value="LEADER">领导</Option>
                <Option value="COLLEAGUE">同部门同事</Option>
                <Option value="OTHERCOLLEAGUE">其他部门同事</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btnWrap">
      <p class="textLeft pdBtm"><span class="addBtn" @click="addExperience">添加其它工作履历</span></p>
      <Button class="defaultBtn formBtn" shape="circle" @click="submitAll">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </div>
</template>

<script>
import personalService from '@/api/personal'
export default {
  props: ['info'],
  data(){
    return{
      newInfo: [{}],
      rules: {
        startYear: [{required: true, message: "请选择开始时间", trigger: 'blur,change', pattern: /.+/}],
        endYear: [{required: true, message: "请选择结束时间", trigger: 'blur,change', pattern: /.+/}],
        company: [{required: true, message: "请输入工作单位", trigger: 'blur,change'}],
        job: [{required: true, message: "请输入职务", trigger: 'blur,change'}],
      },
      submitting: false,
    }
  },
  mounted(){
    // this.newInfo = Object.assign({}, this.info)
    // this.newInfo = Object.assign([], this.info)
    if(this.info.length>0){
      this.newInfo = []
    }
    for(let i=0,l=this.info.length;i<l;i++){
      // this.newInfo[i] = Object.assign({}, this.info[i])
      // let item = this.info[i]
      // if(item.startYear && item.startYear.length == 4){
      //   item.startYear = item.startYear + '-' + "01"
      // }
      // if(item.endYear && item.endYear.length == 4){
      //   item.endYear = item.endYear + '-' + "01"
      // }
      // this.info[i] = item
      this.newInfo.push(Object.assign({}, this.info[i]))
    }
  },
  methods:{
    // 添加
    addExperience(){
      this.newInfo.push({})
    },
    // 移除
    remove(i){
      this.newInfo.splice(i, 1)
    },
    // 提交信息
    submit(){
      let k = 0, l = this.newInfo.length
      for(let i=0;i<l;i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            this.submitting = true
            let condition = Object.assign({}, this.newInfo[i])
            if((typeof condition.startYear) != 'string'){
              let dt = condition.startYear
              dt.setHours(dt.getHours() + 8)
              condition.startYear = dt.getFullYear() + ''
            }
            if((typeof condition.endYear) != 'string'){
              let dt = condition.endYear
              dt.setHours(dt.getHours() + 8)
              condition.endYear = dt.getFullYear() + ''
            }
            // console.log(condition.endYear)
            personalService.saveExperience(condition)
            .then(res => {
              if(res.errorNo==0){
                k++
                this.$parent.$parent.getExperienceList()
              }else{
                this.$Message.error(res.errorMessage)
              }
              this.submitting = false
            }).catch(err => {
              this.submitting = false
              // this.$Message.error(err.message)
              console.log(err.message)
              this.$Message.error('连接服务器失败，请稍后再试')
            })
          }else{
            this.$Message.error('信息未填写完整')
          }
        })
      }
      let _this = this
      let timer = setInterval(function(){
        if(k==l){
          _this.skip()
          clearInterval(timer)
        }
      }, 500)
      setTimeout(function(){
        clearInterval(timer)
      }, 10000)
    },
    // 提交全部信息
    submitAll(){
      let k = 0, l = this.newInfo.length
      for(let i=0; i<l; i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            if((typeof this.newInfo[i].startYear) != 'string'){
              let dt = this.newInfo[i].startYear
              dt.setHours(dt.getHours() + 8)
              this.newInfo[i].startYear = dt.getFullYear() + ''
            }
            if((typeof this.newInfo[i].endYear) != 'string'){
              let dt = this.newInfo[i].endYear
              dt.setHours(dt.getHours() + 8)
              this.newInfo[i].endYear = dt.getFullYear() + ''
            }
            k++
          }else{
            // this.$Message.error('信息未填写完整')
          }
        })
      }
      if(k != l){
        this.$Message.error('信息未填写完整')
        return
      }
      this.submitting = true
      personalService.saveAllExperience(this.newInfo)
      .then(res => {
        if(res.errorNo==0){
          this.$parent.$parent.getExperienceList()
          this.skip()
        }else{
          this.$Message.error(res.errorMessage)
        }
        this.submitting = false
      }).catch(err => {
        this.submitting = false
        // this.$Message.error(err.message)
        console.log(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    setStartYear(val, type, i){
      this.newInfo[i].startYear = val
      this.$refs[`newForm${i}`][0].validateField('startYear')
    },
    setEndYear(val, type, i){
      this.newInfo[i].endYear = val
      this.$refs[`newForm${i}`][0].validateField('endYear')
    },
    skip(){
      this.$emit('Skip', {key: 'experienceInfo'})
    }
  }
}
</script>